import { apiService } from './index';

// Inport types
import { ISelect } from '../shared/types/shared';

export const asyncGetProducts = async (filters: {
    applyPqr?: boolean;
    applyEscalations?: boolean;
}): Promise<ISelect[]> => {
    try {
        if (!filters.applyPqr) delete filters.applyPqr;
        if (!filters.applyEscalations) delete filters.applyEscalations;

        const products: ISelect[] = await apiService.get(
            `/api/product`,
            filters
        );

        return products || [];
    } catch (error) {
        return [];
    }
};
